module.exports = __webpack_public_path__ + "img/Contourline.6c777d7d.png";